import { useState } from 'react';
import s from './send-message-form.module.scss';
import classNames from 'classnames';
import { IconMoodSmile, IconSend, IconX, IconLoader, IconPaperclip } from '@tabler/icons-react';
import TextareaAutosize from 'react-textarea-autosize';
import EmojiPicker from 'emoji-picker-react';
import { useAttachFileModal } from '@features/attach-files';
import { SendOfferButton } from '@features/messanger/send-offer';
import { getExtension } from '@entities/attachment';
import { getFileTypeIcon } from '@utils/lib/fileTypesIcons';
import { formatFileSize } from '@utils/lib/formatFileSize';
import { useSendMessage } from '../model/use-send-message';
import { useTheme } from '@shared/context/ThemeContext';
import { useChatStore } from '@entities/messanger';

export const SendMessageForm = ({ chatId, disabled, suggestions }) => {
  const {
    text,
    setText,
    file,
    setFile,
    isLoading,
    send,
    sendMessage,
    handleKeyDown,
  } = useSendMessage(chatId);

  const [emojiShow, setEmojiShow] = useState(false);
  const { open: openAttachFileModal } = useAttachFileModal();
  const { resolvedTheme } = useTheme();
  const isDisabled = disabled || isLoading;

  // Подсказки показываем только в пустом чате: после отправки первого
  // сообщения (в т.ч. оптимистичного) история непустая — чипсы скрываются
  const hasMessages = useChatStore((state) => state.messageHistory.length > 0);
  const historyLoading = useChatStore((state) => state.historyLoading);
  const showSuggestions =
    Array.isArray(suggestions) &&
    suggestions.length > 0 &&
    !hasMessages &&
    !historyLoading;

  const handleSuggestionClick = (suggestion) => {
    if (isDisabled) return;
    sendMessage(suggestion);
  };

  const handleAttach = () => {
    openAttachFileModal({
      multiple: false,
      maxFiles: 1,
      onSelect: (items) => setFile(items[0] || null),
    });
  };

  return (
    <>
      {showSuggestions && (
        <div className={s.suggestions}>
          {suggestions.map((suggestion) => (
            <button
              key={suggestion}
              type='button'
              className={s.suggestion}
              onClick={() => handleSuggestionClick(suggestion)}
              disabled={isDisabled}
            >
              {suggestion}
            </button>
          ))}
        </div>
      )}
      <div className={classNames(s.inputWrapper, isDisabled && s.disabled)}>
        <SendOfferButton chatId={chatId} disabled={isDisabled} />
        <button
          type="button"
          className={s.attachmentsBtn}
          onClick={handleAttach}
          disabled={isDisabled}
        >
          <IconPaperclip size={20} />
        </button>
        <TextareaAutosize
          onChange={(v) => setText(v.target.value)}
          onKeyDown={handleKeyDown}
          value={isLoading ? '' : text}
          maxRows={5}
          placeholder={isDisabled ? 'Нет соединения…' : 'Напишите сообщение…'}
          disabled={isDisabled}
        />
        <button
          type="submit"
          className={s.emojiBtn}
          onClick={() => setEmojiShow((prev) => !prev)}
          disabled={isDisabled}
        >
          {emojiShow && (
            <div className={s.emojiPicker}>
              <EmojiPicker
                onEmojiClick={(e) => setText((prev) => prev + e.emoji)}
                theme={resolvedTheme}
              />
            </div>
          )}
          <IconMoodSmile />
        </button>
        <button
          type="submit"
          className={s.sendBtn}
          onClick={send}
          disabled={isDisabled}
        >
          {isLoading ? <IconLoader size={18} className={s.spin} /> : <IconSend />}
        </button>
      </div>
      {!isLoading && file && (
        <div className={s.fileBlock}>
          <div className={s.fileIcon}>
            {getFileTypeIcon(getExtension(file))}
          </div>
          <div className={s.fileInfo}>
            <p className={s.fileName}>{file.name}</p>
            <p className={s.fileSize}>{formatFileSize(file.size)}</p>
          </div>
          <button className={s.fileClearBtn} onClick={() => setFile(null)}>
            <IconX />
          </button>
        </div>
      )}
    </>
  );
};
